import React from 'react'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import SingleArticle from '../partials/SingleArticle'

import Container from '../partials/Container'

@inject('Blog', 'Auth', 'User')
export class SinglePost extends React.Component {
  componentWillMount () {
    const _findPost = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending || this.props.User.me.pending) {
          return _findPost()
        }

        this.props.Blog.searchPost(this.props.match.params.seo)
      }, 100)
    }

    _findPost()
  }

  render () {
    const post = this.props.Blog.posts
      .slice()
      .find(p => p.seo === this.props.match.params.seo)

    if (!post) {
      return null
    }

    return (
      <Container {...this.props}>
        <Row>
          <Col>
            <SingleArticle {...post} />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default SinglePost



// WEBPACK FOOTER //
// ./src/components/News/Single/index.js